module.exports = __webpack_public_path__ + "media/happy+super.afc76aef.mp3";